import { nrkFullscreenActive } from '@nrk/core-icons'
import s from './tilpasset-bilde.module.css'

const MARKUP_CLOSE_BUTTON = `<form method="dialog"><button>${nrkFullscreenActive}<span class="nrk-sr">Lukk</span></button></form>`

export default class TilpassetBilde extends HTMLElement {
  #dialogElement
  #showDialogButton
  connectedCallback() {
    if (this.#isFeatureFullWidth() || this.#isFeatureCover() || this.#isDhFullWidth()) {
      for (const source of this.sources) {
        source.setAttribute('sizes', '100vw')
      }
      this.image.setAttribute('sizes', '100vw')
    }

    if (this.#isFeatureCover() && typeof HTMLDialogElement === 'function') {
      this.#dialogElement = document.createElement('dialog')
      this.#dialogElement.setAttribute('class', s.fullskjermDialog)
      this.#dialogElement.setAttribute('aria-label', 'Fullskjermsvisning av bilde')
      this.#dialogElement.insertAdjacentHTML('afterbegin', MARKUP_CLOSE_BUTTON)
      this.#dialogElement.appendChild(this.querySelector('figure').cloneNode(true))

      this.#showDialogButton = document.createElement('button')
      this.#showDialogButton.setAttribute('class', 'nrk-button nrk-color-invert nrk-sr-focus')
      this.#showDialogButton.setAttribute('value', 'show-modal')
      this.#showDialogButton.innerText = 'Vis fullskjermsvisning av bilde'
      this.#showDialogButton?.addEventListener('click', this.#showFullscreenDialog)

      this.after(this.#showDialogButton, this.#dialogElement)

      this.addEventListener('click', this.#showFullscreenDialog)
      this.#dialogElement.addEventListener('click', this.#closeFullscreenDialog)
    }
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#showFullscreenDialog)
    this.#dialogElement?.removeEventListener('click', this.#closeFullscreenDialog)
    this.#showDialogButton?.removeEventListener('click', this.#showFullscreenDialog)
    this.#dialogElement?.remove()
    this.#showDialogButton?.remove()
  }

  #showFullscreenDialog = () => {
    // Start eager loading of image
    this.#dialogElement.querySelector('img').loading = 'eager'
    this.#dialogElement.showModal()
  }

  #closeFullscreenDialog = () => {
    this.#dialogElement.close()
  }

  #isFeatureFullWidth() {
    return !!this.closest?.(
      '.article-feature :is(.remoterenderedcontent-reference,.inlinesanitycontent-reference).fc',
    )
  }

  #isFeatureCover() {
    return !!this.closest?.('.article-feature__cover')
  }

  #isDhFullWidth() {
    return !!this.closest?.('.dh-fullbredde')
  }

  get sources() {
    return this.querySelectorAll('source')
  }

  get image() {
    return this.querySelector('img')
  }
}
